import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import FarmNavigation from "../start/FarmNavigation";
import FarmProductItem from "./FarmProductItem";
import FarmProcessedProductItem from "./FarmProcessedProductItem";
import useFreshProducts from "./useFreshProducts";
import useProcessedProducts from "./useProcessedProducts";
import textData from "./farmProductCopy";
import "../farmLanding.css";

function FarmProductCollectionPage({ kind, collection }) {
  const language = useSelector((state) => state.app.language);
  const sv = language === 0;
  const isFresh = kind === "fresh";
  const Card = isFresh ? FarmProductItem : FarmProcessedProductItem;
  const heading = (isFresh ? textData.freshHeading : textData.processedHeading)[language];
  const { products, loading, error, retry } = collection;

  useEffect(() => { window.scrollTo(0, 0); }, [kind]);

  return <div className="FarmLanding FarmCataloguePage">
    <FarmNavigation />
    <main className={`FarmCatalogueMain ${isFresh ? "FarmProductsFresh" : "FarmProductsProcessed"}`}>
      <div className="FarmLandingContainer">
        <Link className="FarmCatalogueBack" to="/farm/products"><ArrowBackIcon />{sv ? "Till sortimentet" : "Back to products"}</Link>
        <header className="FarmLandingSectionHeading FarmProductsHeading FarmCatalogueHeading">
          <h1>{heading}</h1>
          {isFresh ? <>
            <p className="FarmProductsStatement">{textData.title[language]}</p>
            <p className="FarmLandingSectionIntro">{textData.subtitle[language]}</p>
          </> : textData.processedIntro.map((paragraph, index) => <p className="FarmLandingSectionIntro" key={index}>{paragraph[language]}</p>)}
        </header>
        {loading && <p className="FarmLandingState" role="status">{sv ? "Hämtar produkter…" : "Loading products…"}</p>}
        {error && <div className="FarmLandingState" role="alert">
          <p>{sv ? "Produkterna kunde inte hämtas." : "Products could not be loaded."}</p>
          <button type="button" onClick={retry}>{sv ? "Försök igen" : "Try again"}</button>
        </div>}
        {!loading && !error && (products.length
          ? <div className="FarmProductsGrid FarmCatalogueGrid">{products.map((item) => <Card key={item.firebaseId} item={item} />)}</div>
          : <p className="FarmLandingState">{sv ? "Inga produkter visas just nu." : "No products to show right now."}</p>)}
      </div>
    </main>
    <footer className="FarmCatalogueFooter FarmLandingContainer">
      <Link className="FarmStartWordmark" to="/farm">VERT<span>.farm</span></Link>
      <Link className="FarmLandingTextLink" to="/farm/products">{sv ? "Utforska sortimentet" : "Explore the range"}<ArrowForwardIcon /></Link>
    </footer>
  </div>;
}

export function FarmFreshProductsPage() {
  const collection = useFreshProducts();
  return <FarmProductCollectionPage kind="fresh" collection={collection} />;
}

export function FarmProcessedProductsPage() {
  const collection = useProcessedProducts();
  return <FarmProductCollectionPage kind="processed" collection={collection} />;
}
